import { useAppSelector } from '@hooks';
import { Backdrop, CircularProgress } from '@mui/material';
import { FC } from 'react';

const Loading: FC = () => {
  const { loadingCount } = useAppSelector(state => state.app);

  return (
    <Backdrop
      className='Loading'
      sx={{ zIndex: theme => theme.zIndex.modal + 1 }}
      open={loadingCount > 0}
    >
      <CircularProgress color='secondary' size={60} />
    </Backdrop>
  );
};

export default Loading;
